// Optional: import jQuery
// import $ from 'jquery';
import '../scss/main.scss';
import { BREAKPOINTS, initDebugIndicator, updateDebugIndicator } from './utils/debug';
import { initDropdowns } from './utils/dropdown';

console.log('Hello from main.js!');

// Mobile menu configuration
const MOBILE_BREAKPOINT = 1280; // Breakpoint in pixels where mobile menu should be used

// Mobile menu toggle
function toggleMobileMenu() {
  const navLinks = document.getElementById('nav-links');
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const overlay = document.getElementById('nav-overlay');
  const body = document.body;
  
  if (navLinks && menuToggle && overlay) {
    const isOpen = navLinks.classList.contains('nav-open');
    
    // Toggle menu open/closed
    navLinks.classList.toggle('nav-open');
    menuToggle.classList.toggle('active');
    overlay.classList.toggle('active');
    
    // Prevent body scrolling when menu is open
    if (!isOpen) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = '';
    }
    
    // Change icon based on menu state
    const icon = menuToggle.querySelector('i');
    if (icon) {
      if (!isOpen) {
        icon.classList.remove('fa-bars');
        icon.classList.add('fa-times');
      } else {
        icon.classList.remove('fa-times');
        icon.classList.add('fa-bars');
      }
    }
  }
}

// Close mobile menu when clicking outside
function setupMobileMenuClickOutside() {
  const overlay = document.getElementById('nav-overlay');
  if (overlay) {
    overlay.addEventListener('click', toggleMobileMenu);
  }
}

// Handle window resize to show/hide mobile menu appropriately
function handleWindowResize() {
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const navLinks = document.getElementById('nav-links');
  const overlay = document.getElementById('nav-overlay');
  const body = document.body;
  
  if (window.innerWidth > MOBILE_BREAKPOINT) {
    // Reset mobile menu state when viewport becomes larger than mobile breakpoint
    if (navLinks && navLinks.classList.contains('nav-open')) {
      navLinks.classList.remove('nav-open');
      if (menuToggle) menuToggle.classList.remove('active');
      if (overlay) overlay.classList.remove('active');
      body.style.overflow = '';
      
      const icon = menuToggle?.querySelector('i');
      if (icon) {
        icon.classList.remove('fa-times');
        icon.classList.add('fa-bars');
      }
    }
    
    // Reset dropdown state on desktop view
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
    dropdownToggles.forEach(toggle => {
      toggle.classList.remove('active');
      
      const navDropdown = toggle.closest('.nav-dropdown');
      const dropdownMenu = navDropdown ? navDropdown.querySelector('.dropdown-menu') : null;
      if (dropdownMenu) {
        dropdownMenu.classList.remove('show');
      }
    });
  }
  
  // Update debug indicator
  updateDebugIndicator();
}

// Initialize mobile menu
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.getElementById('mobile-menu-toggle');
  if (menuToggle) {
    menuToggle.addEventListener('click', toggleMobileMenu);
  }
  
  // Setup click outside to close
  setupMobileMenuClickOutside();
  
  // Initialize dropdown menus
  initDropdowns();
  
  // Initialize debug indicator
  initDebugIndicator();
  
  // Handle window resize
  window.addEventListener('resize', handleWindowResize);
  
  // Initialize based on current window size
  handleWindowResize();
});

// FAQ toggle
function toggleFAQ(button) {
  // Toggle the content visibility
  const content = button.nextElementSibling;
  content.classList.toggle('hidden');

  // Toggle the icon rotation
  const icon = button.querySelector('i');
  icon.classList.toggle('rotate-180');
 
}

// Make toggleFAQ available globally
window.toggleFAQ = toggleFAQ;

AOS.init({
  // Global settings
  duration: 800, // Animation duration in ms
  once: false,   // Whether animation should happen only once
  offset: 120,   // Offset (in px) from the original trigger point
  delay: 0,      // Delay animation (ms)
  easing: 'ease' // Default easing for AOS animations
});